import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { NoneSelectedMessage } from "../../common/NoneSelected";
import { getContractByCaseId } from "../../../redux/contract/thunks";
import { getCaseStateIcon } from "../../../commonFunctions/commonFunctions";
import { ROUTE_PANEL } from "../../routes/routesConstants";
import babyIcon from "../../../images/baby.svg";

function ChildTicketsInfo(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const currentCase = useSelector((state) => state.currentCase?.currentCase?.case);
  const contract = useSelector((state) => state.contract?.contract);
  const caseStates = useSelector((state) => state.caseStates?.caseStates || []);

  const tickets =
    props.childTickets ||
    currentCase?.childTickets ||
    contract?.case?.childTickets ||
    [];

  const handleClickChild = (childCaseId) => {
    if (!childCaseId) {
      return;
    }

    dispatch(getContractByCaseId({ query: `?caseId=${childCaseId}` }));

    if (history?.location?.pathname !== ROUTE_PANEL) {
      history.push(ROUTE_PANEL);
    }

    if (typeof window !== "undefined" && window.scrollTo) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  if (!tickets || tickets.length === 0) {
    return <NoneSelectedMessage message={t("ChildTickets.NoChildren")} />;
  }

  return (
    <div style={{ marginTop: "0.75rem", display: "flex", flexDirection: "column", rowGap: "0.625rem" }}>
      {tickets.map((child, index) => {
        const titleText =
          child.mspid ||
          child.caseNumber ||
          (child.caseId ? `#${child.caseId}` : "");

        const effectiveStateId =
          child.stateId !== undefined && child.stateId !== null
            ? child.stateId
            : caseStates.find((s) => s.description === child.stateDescription)?.stateId;

        const stateIcon = getCaseStateIcon(effectiveStateId);

        return (
          <div
            key={child.caseId || index}
            data-testid={`child-ticket-item-${child.caseId || index}`}
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "0.25rem 0",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", minWidth: 0 }}>
              <img
                src={babyIcon}
                alt=""
                data-testid="child-ticket-icon"
                style={{ width: "1.125rem", height: "1.125rem", flexShrink: 0 }}
              />
              <Tooltip title={t("ChildTickets.OpenTicket")}>
                <button
                  type="button"
                  data-testid={`child-ticket-link-${child.caseId || index}`}
                  onClick={() => handleClickChild(child.caseId)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    margin: 0,
                    font: "inherit",
                    color: "#007BC0",
                    fontWeight: 700,
                    fontSize: "0.8125rem",
                    cursor: "pointer",
                    textAlign: "left",
                    textDecoration: "underline",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {titleText}
                </button>
              </Tooltip>
            </div>
            {child.stateDescription && (
              <div
                style={{
                  marginTop: "0.25rem",
                  paddingLeft: "1.625rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.375rem",
                }}
              >
                <img
                  src={stateIcon}
                  alt=""
                  data-testid={`child-ticket-state-icon-${child.caseId || index}`}
                  style={{ width: "0.875rem", height: "0.875rem", flexShrink: 0 }}
                />
                <span
                  data-testid={`child-ticket-status-${child.caseId || index}`}
                  style={{
                    color: "#000000",
                    fontSize: "0.75rem",
                  }}
                >
                  {child.stateDescription}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export { ChildTicketsInfo };
